"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEAL_LOST_STAGE = exports.DEAL_WON_STAGE = exports.DEAL_STAGES = void 0;
exports.DEAL_STAGES = [
    'lead',
    'qualified',
    'proposal',
    'interviewing',
    'offer',
    'placed',
    'lost'
];
/** Dropping a deal into one of these stages marks the deal won (→ Hiring Request). */
exports.DEAL_WON_STAGE = 'placed';
exports.DEAL_LOST_STAGE = 'lost';
//# sourceMappingURL=crm.js.map